var $f0cb2d759ccff6de$exports = {};
/**
 * Theme-related elements.
 * @property {HTMLElement} themeToggle - The theme toggle button element.
 * @property {HTMLElement} body - The body element of the document.
 * @property {HTMLElement} themeIcon - The theme icon inside the toggle button.
 */ const $f0cb2d759ccff6de$var$themeToggle = document.getElementById("theme-toggle");
const $f0cb2d759ccff6de$var$body = document.body;
const $f0cb2d759ccff6de$var$themeIcon = $f0cb2d759ccff6de$var$themeToggle.querySelector("i");
/**
 * Updates the theme of the website.
 * Removes any existing theme classes and applies the new theme.
 * Saves the theme in local storage.
 *
 * @param {string} theme - The new theme to be applied ("light-mode" or "dark-mode").
 */ function $f0cb2d759ccff6de$var$updateTheme(theme) {
    $f0cb2d759ccff6de$var$body.classList.remove("light-mode", "dark-mode");
    $f0cb2d759ccff6de$var$body.classList.add(theme);
    $f0cb2d759ccff6de$var$updateThemeIcon(theme);
    localStorage.setItem("theme", theme);
}
/**
 * Updates the theme toggle icon based on the current theme.
 *
 * @param {string} theme - The current theme ("light-mode" or "dark-mode").
 */ function $f0cb2d759ccff6de$var$updateThemeIcon(theme) {
    $f0cb2d759ccff6de$var$themeIcon.classList = theme === "light-mode" ? "fas fa-sun" : "fas fa-moon";
}
/**
 * Retrieves the saved theme from local storage.
 * If no saved theme is found, it follows the system's preferred theme.
 */ const $f0cb2d759ccff6de$var$savedTheme = localStorage.getItem("theme");
if ($f0cb2d759ccff6de$var$savedTheme) $f0cb2d759ccff6de$var$updateTheme($f0cb2d759ccff6de$var$savedTheme);
else {
    // If no saved theme, follow system setting
    const prefersLight = window.matchMedia("(prefers-color-scheme: light)").matches;
    $f0cb2d759ccff6de$var$body.classList.add(prefersLight ? "light-mode" : "dark-mode");
    $f0cb2d759ccff6de$var$updateThemeIcon(prefersLight ? "light-mode" : "dark-mode");
}
/**
 * Listens for changes in the system color scheme and updates the theme accordingly.
 * This only applies if the user has not manually selected a theme.
 */ window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e)=>{
    if (!localStorage.getItem("theme")) $f0cb2d759ccff6de$var$updateTheme(e.matches ? "dark-mode" : "light-mode");
});
/**
 * Toggles the theme manually when the user clicks the theme toggle button.
 */ $f0cb2d759ccff6de$var$themeToggle.addEventListener("click", ()=>{
    const newTheme = $f0cb2d759ccff6de$var$body.classList.contains("light-mode") ? "dark-mode" : "light-mode";
    $f0cb2d759ccff6de$var$updateTheme(newTheme);
});


//# sourceMappingURL=path0.4780c5ab.js.map
